export default "__VITE_ASSET__DYtuam58__"